'use strict';

document.addEventListener('DOMContentLoaded', function () {
  const bar   = document.getElementById('sticky-atc-bar');
  const rawEl = document.getElementById('sticky-product-json');
  if (!bar || !rawEl) return;

  const variants   = JSON.parse(rawEl.textContent);
  const sectionId  = bar.dataset.section;
  const btn        = document.getElementById('sticky-atc-btn');
  const priceEl    = document.getElementById('sticky-atc-price');
  const selects    = bar.querySelectorAll('.sticky-atc-select');

  // ── 1. スクロールで表示 / 非表示 ──────────────────────────────
const originalBtn = document.querySelector('[name="add"]');
if (originalBtn) {
  let hasBeenVisible = false;
  new IntersectionObserver(([e]) => {
    if (e.isIntersecting) {
      hasBeenVisible = true;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    } else if (hasBeenVisible) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
  }).observe(originalBtn);
}

  // ── 2. ユーティリティ ─────────────────────────────────────────
  function findVariant(options) {
    return variants.find(v => v.options.every((o, i) => o === options[i])) || null;
  }

  function formatPrice(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      const fmt = (window.theme && window.theme.moneyFormat)
        || window.Shopify.money_format
        || '¥{{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    // JPY フォールバック（Shopify は内部で ×100 保持）
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  // ── 3. sticky バーの UI 更新 ───────────────────────────────────
  function updateUI(variant) {
    if (!variant) { btn.disabled = true; return; }
    btn.dataset.variantId = variant.id;
    if (priceEl) priceEl.textContent = formatPrice(variant.price);
    if (!btn.dataset.busy) {
      btn.disabled    = !variant.available;
      btn.textContent = variant.available ? 'カートに追加' : '売り切れ';
    }
  }

  // ── 4. sticky select → メインフォームに反映 ───────────────────
  //    Dawn デフォルトはボタン型 (variant-radios)、ドロップダウン型 (variant-selects) にも対応
  function syncToMain(options) {

    // ボタン型（variant-radios）の場合
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      const fieldsets = variantRadios.querySelectorAll('fieldset');
      fieldsets.forEach((fieldset, i) => {
        if (options[i] === undefined) return;
        const radio = fieldset.querySelector(
          `input[type="radio"][value="${CSS.escape(options[i])}"]`
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      return;
    }

    // ドロップダウン型（variant-selects）の場合
    document.querySelectorAll('variant-selects select').forEach((sel, i) => {
      if (options[i] !== undefined && sel.value !== options[i]) {
        sel.value = options[i];
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

// ── 5. sticky select 変更イベント ─────────────────────────────
  selects.forEach(sel => {
    sel.addEventListener('change', () => {
      const opts    = Array.from(selects).map(s => s.value);
      const variant = findVariant(opts);
      updateUI(variant);
      autosizeSelects(); // ← 追加
      syncToMain(opts);
    });
  });

 // ── 6. メインフォーム変更 → sticky に反映 ────────────────────
  //    変更イベントから直接オプション値を読む（URL 更新待ち不要）
  document.addEventListener('change', function (e) {
    const container =
      e.target.closest('variant-radios') ||
      e.target.closest('variant-selects');
    if (!container) return;

    const mainOptions = [];

    // ボタン型
    container.querySelectorAll('fieldset').forEach(fieldset => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) mainOptions.push(checked.value);
    });

    // ドロップダウン型
    if (mainOptions.length === 0) {
      container.querySelectorAll('select').forEach(sel => mainOptions.push(sel.value));
    }

    if (mainOptions.length === 0) return;

    const variant = findVariant(mainOptions);
    if (!variant) return;

    // sticky select を同期
    selects.forEach((sel, i) => {
      if (mainOptions[i] !== undefined) sel.value = mainOptions[i];
    });
    updateUI(variant);
    autosizeSelects(); // ← 追加
  });

  // ── 7. 価格 DOM 変化も監視（section rendering による更新に対応） ──
  const mainPriceParent = document.getElementById('price-' + sectionId);
  if (mainPriceParent) {
    new MutationObserver(() => {
      // URL の variant パラメータからも念のため確認
      const urlId  = parseInt(new URLSearchParams(location.search).get('variant') || '0');
      const urlVar = variants.find(v => v.id === urlId);
      if (urlVar && priceEl) priceEl.textContent = formatPrice(urlVar.price);
    }).observe(mainPriceParent, { childList: true, subtree: true, characterData: true });
  }

 // 8. カートに追加
btn.addEventListener('click', async function () {
  const variantId = parseInt(this.dataset.variantId);
  if (!variantId || this.disabled || this.dataset.busy) return;
  this.disabled = true; this.dataset.busy = 'true'; this.textContent = '追加中...';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || 'カートへの追加に失敗しました'); }
    const cartData = await res.json();
    this.textContent = '✓ 追加しました';

    // Dawnのカート通知ポップアップを表示
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
  setTimeout(() => cartNotification.renderContents(cartData), 0);
} else {
  refreshCartUI();
}
  } catch (err) { alert(err.message); }
  finally {
    setTimeout(() => {
      delete this.dataset.busy;
      const v = variants.find(v => v.id === variantId);
      updateUI(v || null);
    }, 2000);
  }
});

  // ── 9. Dawn のカート UI を更新 ───────────────────────────────
  function refreshCartUI() {
    // Dawn の pub/sub で cart-notification / cart-drawer を自動更新
    if (typeof publish === 'function') {
      try { publish('cart-update', { source: 'sticky-atc' }); } catch (_) {}
    }

    // カートアイコンのバッジ件数を更新
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
          bubble.querySelectorAll('span').forEach(s => {
            s.textContent = s.classList.contains('visually-hidden')
              ? cart.item_count + ' items'
              : cart.item_count;
          });
        });
      })
      .catch(() => {});
  }

  // ── 10. セレクトの幅をコンテンツに合わせて自動調整（モバイルのみ）──
  function autosizeSelects() {
    if (window.innerWidth > 749) return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    selects.forEach(sel => {
      const text = sel.options[sel.selectedIndex]?.text || '';
      const cs = window.getComputedStyle(sel);
      ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
      const textWidth = ctx.measureText(text).width;
      const paddingL = parseFloat(cs.paddingLeft) || 5;
      const arrowW = 22;
      sel.style.width = Math.ceil(textWidth + paddingL + arrowW) + 'px';
    });
  }

  // ── 11. 初期化 ────────────────────────────────────────────────
  const initId = parseInt(btn.dataset.variantId || '0');
  updateUI(variants.find(v => v.id === initId) || null);
  autosizeSelects();
  window.addEventListener('resize', autosizeSelects);
});